export const PostSubmissionOptions = {
  THANK_YOU_MESSAGE: 'thankYouMessage',
  REDIRECT_PAGE: 'redirectPage'
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/constants/FormCreation.ts#L32
 */
export const RegularFormTypes = {
  REGULAR: 'REGULAR',
  SHAREABLE: 'SHAREABLE'
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/constants/FormMetaDataProperties.ts
 */
export const MetaDataProperties = {
  IS_RENDER_RAW_HTML_ENABLED: 'renderRawHtml',
  IS_ALLOW_COOKIE_RESET_ENABLED: 'allowCookieReset',
  INBOX_ID: 'inboxId'
};